'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-facebook/lib/constants/ColorScheme.js
// module id = 383
// module chunks = 0